import { freedomPrimeApi } from '@/features/freedom-prime';

export const withFreedomPrime = () => {
  window.FreedomPrime = {
    ...window.FreedomPrime,
    fetchToken: freedomPrimeApi.fetchLogin,
  };
};
